import videojs from 'video.js';

export function addCastButton(playerRef: any) {
  const player = playerRef;
  const Button = videojs.getComponent('Button');

  // @ts-ignore - clickHandler is supported by VideoJS Button at runtime
  const castButton = new Button(player, {
    // @ts-ignore
    clickHandler: () => {
      // Find and trigger the google-cast-launcher element that was created
      const castLauncher = document.querySelector(
        '.chromeCastBtnContainer google-cast-launcher'
      ) as any;
      if (castLauncher) {
        castLauncher.click();
      }
    }
  });

  castButton.addClass('vjs-cast-button');
  castButton.controlText('Cast');

  // Create the proper Cast button structure (same as old working code)
  if (!document.querySelector('.chromeCastBtnContainer')) {
    const castHolder = document.createElement('div');
    const googleCastLauncher = document.createElement('google-cast-launcher');

    googleCastLauncher.setAttribute('class', 'chromeCastIcon');
    castHolder.setAttribute('title', 'Cast');
    castHolder.setAttribute('style', '--disconnected-color: #4285f4;');
    castHolder.setAttribute('id', 'chromeCastBtnContainer');
    castHolder.className = 'chromeCastBtnContainer';
    castHolder.appendChild(googleCastLauncher);

    const videoEL = player && player.el();
    if (videoEL) {
      videoEL.appendChild(castHolder);
      // Color the cast icon
      fillColorToCastIcon();
    }
  }

  const controlBar = player.getChild('ControlBar');
  if (controlBar) {
    controlBar.addChild(castButton);
  } else {
    player.addChild(castButton);
  }
}

function fillColorToCastIcon() {
  const castIcon = document.querySelector('google-cast-launcher');
  if (
    castIcon &&
    castIcon.shadowRoot &&
    castIcon.shadowRoot.querySelectorAll('path')
  ) {
    castIcon.shadowRoot
      .querySelectorAll('path')
      .forEach((element) => (element.style.fill = '#4285f4'));
  }
}
